"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChatAdapter = void 0;
const domain_1 = require("@home-health-notify/domain");
const templates_1 = require("@home-health-notify/templates");
const lodash_1 = require("lodash");
const Urls_1 = require("../Urls");
const utils_1 = require("../utils");
/* eslint-disable no-useless-catch */
class ChatAdapter {
    constructor(httpAdapter, config) {
        this.httpAdapter = httpAdapter;
        this.config = config;
    }
    syncChatList(data, organizationId, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const chatList = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.syncChatList, data, Object.assign({ signal: abortContext === null || abortContext === void 0 ? void 0 : abortContext.newAbortSignal(new AbortController()) }, (organizationId && {
                    headers: {
                        "x-hhn-active-org-id": organizationId,
                    },
                })));
                return (0, domain_1.CompletedResult)(chatList.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getChatList(data, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const chatList = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.chatList, data, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(chatList.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getGroupChatList(data, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const newData = Object.assign(Object.assign({}, data), { chatType: domain_1.CHAT_TYPE.GROUP });
                return yield this.getChatList(newData, context);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    syncGroupChatList(data, organizationId, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            const currentTime = (0, domain_1.currentEpoch)();
            // eslint-disable-next-line no-useless-catch
            try {
                const chatListResponse = yield this.syncChatList(data, organizationId, abortContext);
                if (!chatListResponse.isAborted) {
                    if (chatListResponse.data.hasNext) {
                        const syncErrorInfo = {
                            message: `Chat-list sync page size exceeded! offline duration: ${(currentTime - data.lastSyncedAt) / 60000} minutes`,
                            chatType: data.chatType,
                            groupType: data.groupType,
                            lastSyncedAt: data.lastSyncedAt,
                            hiddenChats: data.hiddenChats,
                            limit: data.limit,
                        };
                        throw new domain_1.SyncException(syncErrorInfo);
                    }
                }
                return chatListResponse;
            }
            catch (e) {
                throw e;
            }
        });
    }
    getPrivateChatList(data, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const newData = Object.assign(Object.assign({}, data), { chatType: domain_1.CHAT_TYPE.PRIVATE });
                return yield this.getChatList(newData, context);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    syncPrivateChatList(data, organizationId, abortContext) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const currentTime = (0, domain_1.currentEpoch)();
                const chatListResponse = yield this.syncChatList(data, organizationId, abortContext);
                if (!chatListResponse.isAborted) {
                    if (chatListResponse.data.hasNext) {
                        const syncErrorInfo = {
                            message: `Chat-list sync page size exceeded! offline duration: ${(currentTime - data.lastSyncedAt) / 60000} minutes`,
                            chatType: data.chatType,
                            groupType: data.groupType,
                            lastSyncedAt: data.lastSyncedAt,
                            hiddenChats: data.hiddenChats,
                            limit: data.limit,
                        };
                        throw new domain_1.SyncException(syncErrorInfo);
                    }
                }
                return chatListResponse;
            }
            catch (e) {
                throw e;
            }
        });
    }
    getGroupInfo(groupId, source, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const groupInfo = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.groupInfo(groupId), Object.assign({ signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()) }, (source && { headers: { "x-hhn-source": source } })));
                return (0, domain_1.CompletedResult)(groupInfo.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getBroadcastInfo(broadcastId, source, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const broadcastInfo = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.broadcastInfo(broadcastId), Object.assign({ signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()) }, (source && { headers: { "x-hhn-source": source } })));
                return (0, domain_1.CompletedResult)(broadcastInfo.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    syncBroadcastChatList(data, organizationId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            // eslint-disable-next-line no-useless-catch
            try {
                const currentTime = (0, domain_1.currentEpoch)();
                const chatListResponse = yield this.syncChatList(data, organizationId, context);
                if (!chatListResponse.isAborted) {
                    if (chatListResponse.data.hasNext) {
                        const syncErrorInfo = {
                            message: `Chat-list sync page size exceeded! offline duration: ${(currentTime - data.lastSyncedAt) / 60000} minutes`,
                            chatType: data.chatType,
                            groupType: data.groupType,
                            lastSyncedAt: data.lastSyncedAt,
                            hiddenChats: data.hiddenChats,
                            limit: data.limit,
                        };
                        throw new domain_1.SyncException(syncErrorInfo);
                    }
                }
                return chatListResponse;
            }
            catch (e) {
                throw e;
            }
        });
    }
    enableDisableGroupEmail(requestData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.groupEmail, requestData);
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    createNewEpisode(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.newEpisode, data);
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    addGroup(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.group, data);
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    addBroadcastGroup(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.broadcast, data);
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    addMembers(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.member, data);
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    addBroadcastMembers(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.broadcastMember, data);
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    getNonPatientGroups(params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const nonPatientChats = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.nonPatientChat, {
                    params,
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(nonPatientChats.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getExportChats(params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.exportChat, {
                    params,
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    initiateExportMedia(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.initiateMediaChat, {
                    params,
                });
                return response.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    initiateExportChat(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.initiateExportChat, {
                    params,
                });
                return response.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    getGroupAssets(chatId, assetType, params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(`${this.config.baseUrl + Urls_1.urls.chat(chatId)}/${assetType}`, {
                    params,
                });
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    getBroadcastChatList(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const newData = Object.assign(Object.assign({}, data), { chatType: domain_1.CHAT_TYPE.BROADCAST });
                return yield this.getChatList(newData);
            }
            catch (e) {
                throw e;
            }
        });
    }
    revokeReferral(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.revokeReferral, data);
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    deleteBroadcastGroup(broadcastId) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.delete(this.config.baseUrl + Urls_1.urls.broadcastInfo(broadcastId));
            }
            catch (e) {
                throw e;
            }
        });
    }
    deleteGroup(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.delete(this.config.baseUrl + Urls_1.urls.chatList, {
                    data,
                });
            }
            catch (e) {
                throw e;
            }
        });
    }
    hideUnHideGroup(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.groupSettings, data);
            }
            catch (e) {
                throw e;
            }
        });
    }
    muteNotifications(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.groupSettings, data);
            }
            catch (e) {
                throw e;
            }
        });
    }
    updateVisibleToPatient(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.groupSettings, data);
            }
            catch (e) {
                throw e;
            }
        });
    }
    updateVisibleToPhysician(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.put(this.config.baseUrl + Urls_1.urls.groupSettings, data);
            }
            catch (e) {
                throw e;
            }
        });
    }
    leaveAndDeleteGroup(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.delete(this.config.baseUrl + Urls_1.urls.leaveAndDeleteGroup, { data });
            }
            catch (e) {
                throw e;
            }
        });
    }
    advanceSearch(advanceSearchPayload, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.advanceSearch, {
                    params: Object.assign(Object.assign({}, advanceSearchPayload), { departments: encodeURIComponent(advanceSearchPayload.departments) }),
                    paramsSerializer: (params) => (0, utils_1.transformRequestOptions)(params),
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    fetchRecentContacts(params, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.recentContacts, {
                    params,
                    paramsSerializer: (params) => (0, utils_1.transformRequestOptions)(params),
                    signal: context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getChatTemplates(chatId, selectedRole, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.templates(chatId, selectedRole), context
                    ? { signal: context.newAbortSignal(new AbortController()) }
                    : undefined);
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getTemplate(templateKey) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const template = (0, lodash_1.cloneDeep)(templates_1.TEMPLATES_SCHEMAS[templateKey]);
                return Promise.resolve(template);
            }
            catch (e) {
                throw e;
            }
        });
    }
    getRpmReading(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.rpmReading, {
                    params,
                });
                return response.data.data;
            }
            catch (e) {
                throw e;
            }
        });
    }
    managePatientDevice(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.patch(this.config.baseUrl + Urls_1.urls.managePatientDevice, params);
                return response.data.data;
            }
            catch (e) {
                if (e.response) {
                    console.error("Error response:", e.response);
                    return {
                        responseType: e.response.data.responseType || "UNKNOWN_ERROR",
                    };
                }
                else if (e.request) {
                    console.error("Error request:", e.request);
                }
                else {
                    console.error("Error message:", e.message);
                }
                throw e;
            }
        });
    }
    exportRequest(params) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.exportRequest, params);
            }
            catch (e) {
                if (e.response) {
                    console.error("Error response:", e.response);
                }
                else if (e.request) {
                    console.error("Error request:", e.request);
                }
                else {
                    console.error("Error message:", e.message);
                }
                throw e;
            }
        });
    }
    getAssignedPatients(userId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(this.config.baseUrl + Urls_1.urls.assignedPatients(userId), {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    getUserMedia(userId, context) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const response = yield this.httpAdapter.get(`${this.config.baseUrl + Urls_1.urls.userMedia(userId)}&mediaLimit=5`, {
                    signal: context === null || context === void 0 ? void 0 : context.newAbortSignal(new AbortController()),
                });
                return (0, domain_1.CompletedResult)(response.data.data.data);
            }
            catch (e) {
                if (e instanceof Error && e.name === "CanceledError") {
                    return domain_1.AbortedResult;
                }
                throw e;
            }
        });
    }
    removeMember(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.delete(this.config.baseUrl + Urls_1.urls.member, {
                    data,
                });
            }
            catch (e) {
                throw e;
            }
        });
    }
    removeBroadcastMember(data) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield this.httpAdapter.post(this.config.baseUrl + Urls_1.urls.broadcastDeleteMember, data);
            }
            catch (e) {
                throw e;
            }
        });
    }
}
exports.ChatAdapter = ChatAdapter;
